import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { getCivilDetalle } from '../api/consultaCivilApi';
import { UseAuth } from "../hooks/useAuth";
import { withRouter } from "../hooks/withRouter";
import LoadingCircle from './LoadingCircle';

function replaceSpecialCharacter(text) {
    if (text === null) {
        return "----";
    }
    if (text === undefined) {
        return "----";
    }
    return text.replace(/�/, 'Ñ');
}
function BusquedaCivilDetalles(props) {
    const { location } = props.router;
    const [acta, setActa] = useState([]);
    const [defuncion, setDefuncion] = useState([]);
    const [padres, setPadres] = useState([]);
    const [hermanos, setHermanos] = useState([]);
    const [conyugue, setConyugue] = useState([]);
    const [hijos, setHijos] = useState([]);
    const [divorcio, setDivorcio] = useState([]);
    const [matrimonio, setMatrimonio] = useState([]);
    const { accessToken } = UseAuth();
    const [isSearching, setIsSearching] = useState(true);


    const id = location.pathname.split("/")[2];

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getCivilDetalle(accessToken, id);
                setActa(response.ACTA);
                setDefuncion(response.DEFUNCIONES);
                setPadres(response.PADRES);
                setHermanos(response.HERMANOS);
                setConyugue(response.CONYUGUE);
                setHijos(response.HIJOS);
                setMatrimonio(response.MATRIMONIO);
                setDivorcio(response.DIVORCIO);



                setIsSearching(false);

                console.log("aqui esta la respuesta ", response);
            } catch (error) {
                console.error("Error al obtener los detalles:", error);
            }
        };

        fetchData();
    }, [accessToken, id]);


    return (
        <>
            <div>
                <div className='top-bar2'>
                    <div className="top-bar">
                        <div className="logo">
                            <Link to="/">
                                <button className="logo-button">
                                    <img src="/img/logo.png" alt="Logo de la empresa" style={{ width: '50px', marginLeft: '20px' }} />
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div class="acta-container">
                    <div><h1>REGISTRO CIVIL</h1></div>

                    {isSearching && <p>Realizando búsqueda...</p>}
                    <div>
                        {isSearching && <LoadingCircle isSearching={isSearching} />}
                        {!isSearching && <p>Búsqueda completada.</p>}
                    </div>


                    {acta && acta.length > 0 && (

                        <div className='her'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Acta de Nacimiento</h2>


                            <div className='acta'>

                                <div className='columna'>

                                    <h2>Datos del registrado</h2>
                                    <p><b>Nombre:</b> {replaceSpecialCharacter(acta[0].NOMBRE_REGISTRADO)}</p>
                                    <p><b>Fecha de Nacimiento:</b> {acta[0].FECHA_NAC}</p>
                                    <p><b>Fecha de Registro:</b> {acta[0].FECHA_REG}</p>
                                    <p><b>Sexo:</b> {acta[0].SEXO_COMPLETO}</p>
                                    <p><b>Registrado:</b> {acta[0].REGISTRADO}</p>
                                    <p><b>Localidad: </b> {replaceSpecialCharacter(acta[0].ESTADO)}</p>
                                    <p><b>Municipio:</b> {acta[0].MUNICIPIO}</p>
                                    <p><b>Estado:</b> {acta[0].ESTADO}</p>
                                    <p><b>País:</b> {acta[0].PAIS}</p>
                                    <p><b>CRIP:</b> {acta[0].CRIP}</p>
                                </div>
                                <div className='columna'>
                                    <h2>Padres</h2>

                                    <p><b>Padre:</b> {replaceSpecialCharacter(acta[0].PADRE)}</p>
                                    <p><b>Edad:</b> {acta[0].EDAD_PADRE}</p>
                                    <p><b>País:</b> {acta[0].PAIS_PADRE}</p>
                                    <p><b>Fecha de Nacimiento del Padre:</b> {acta[0].FECHA_NAC_PADRE}</p>
                                    <br />
                                    <br />
                                    <p><b>Madre:</b> {replaceSpecialCharacter(acta[0].MADRE)}</p>
                                    <p><b>Edad Madre:</b> {acta[0].EDAD_MADRE}</p>
                                    <p><b>País Madre:</b> {acta[0].PAIS_MADRE}</p>
                                    <p><b>Fecha de Nacimiento de la Madre:</b> {acta[0].FECHA_NAC_MADRE}</p>

                                </div>
                                <div className='columna'>
                                    <h2>Datos Acta</h2>
                                    <p><b>Libro:</b> {acta[0].LIBRO}</p>
                                    <p><b>Tomo:</b> {acta[0].TOMO}</p>
                                    <p><b>Foja:</b> {acta[0].FOJA}</p>
                                    <p><b>Mun. Oficialia:</b> {acta[0].MUN_OFI}</p>
                                    <p><b>Acta:</b> {acta[0].ACTA}</p>
                                    <p><b>Número Oficial:</b> {acta[0].NUM_OFI}</p>
                                    <p><b>Oficialía:</b> {acta[0].OFICIALIA}</p>
                                    <p><b>Estado de la Oficialía:</b> {acta[0].ESTADO_OFI}</p>
                                </div>
                            </div>

                        </div>
                    )}




                    {defuncion && defuncion.length > 0 && (
                        <div className='her'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Actas de Defunción</h2>

                            {defuncion.map((defuncion, index) => (
                                <div key={index}>
                                    <div className='hermano'>


                                        <div className='columna'>
                                            <h2>Datos De Defunció</h2>
                                            <p><b>Nombre</b> {replaceSpecialCharacter(defuncion.NOMBRE_DEFUNCION)}</p>
                                            <p><b>Fecha de Nacimiento</b> {defuncion.FECHA_NAC}</p>
                                            <p><b>Estado:</b> {defuncion.entidad_reg}{"\n"}</p>
                                           
                                            <p><b>Causas de la Defuncion :</b></p> 
                                            <p>{defuncion.causas_defuncion} </p>
                                          

                                        </div>


                                        <div className='columna'>
                                        <br />
                                        <br />
                                            
                                            <p><b>Municipio:</b> {defuncion.localidad_reg}</p>
                                            <p><b>Localidad:</b> {defuncion.municipio_reg}</p>
                                            {/* <br /> */}
                                            {/* <h2>Información de Defunción</h2> */}
                                            <p><b>Fecha de Defunción:</b> {defuncion.fecha_defuncion}</p>
                                    
                                          

                                        </div>
                                      
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}


                    {matrimonio && matrimonio.length > 0 && (
                        <div className='her'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Actas de Matrimonio</h2>

                            {matrimonio.map((matrimonio, index) => (
                                <div key={index}>
                                    <div className='hermano'>


                                        <div className='columna'>
                                            <h2>Datos De El Contrayente</h2>
                                            <p><b>El Contrayente:</b> {replaceSpecialCharacter(matrimonio.CONTRAYENTE1)}</p>
                                            <p><b>Edad:</b> {matrimonio.EDAD1}</p>
                                            <p><b>Localidad:</b> {matrimonio.NACIONALIDAD1}</p>
                                            <p><b>Registrado:</b> {matrimonio.LOCALIDAD1}</p>
                                            <p><b>Municipio:</b> {matrimonio.MUNICIPIO1}</p>
                                            <p><b>Estado:</b> {matrimonio.ESTADO1}{"\n"}</p>
                                            <br />
                                            <br />
                                            <h2>Padres De El Contrayente</h2>

                                            <p><b>Nombre del Padre:</b> {replaceSpecialCharacter(matrimonio.PADRE_CONTRAYENTE1)}</p>
                                            <p><b>Nacion Padre:</b> {matrimonio.NACION_PADRE1}</p>
                                            <p><b>Nombre de la Madre:</b> {replaceSpecialCharacter(matrimonio.MADRE_CONTRAYENTE1)}</p>
                                            <p><b>Nacion Madre:</b> {matrimonio.NACION_MADRE1}</p>

                                        </div>
                                        <div className='columna'>
                                            <h2>Datos De El Contrayente</h2>
                                            <p><b>El Contrayente:</b> {replaceSpecialCharacter(matrimonio.CONTRAYENTE2)}</p>
                                            <p><b>Edad:</b> {matrimonio.EDAD2}</p>
                                            <p><b>Localidad:</b> {matrimonio.NACIONALIDAD2}</p>
                                            <p><b>Registrado:</b> {matrimonio.LOCALIDAD2}</p>
                                            <p><b>Municipio:</b> {matrimonio.MUNICIPIO2}</p>
                                            <p><b>Estado:</b> {matrimonio.ESTADO2}</p>
                                            <br />
                                            <br />
                                            <h2>Padres De El Contrayente</h2>
                                            <p><b>Nombre del Padre:</b> {replaceSpecialCharacter(matrimonio.PADRE_CONTRAYENTE2)}</p>
                                            <p><b>Nacion Padre:</b> {matrimonio.NACION_PADRE1_1}</p>
                                            <p><b>Nombre de la Madre:</b> {replaceSpecialCharacter(matrimonio.MADRE_CONTRAYENTE2)}</p>
                                            <p><b>Nacion Madre:</b> {matrimonio.NACION_MADRE1_1}</p>
                                        </div>
                                        <div className='columna'>
                                            <h2>Datos Acta</h2>
                                            <p><b>Fecha Reg:</b> {matrimonio.FECHA_REGISTRO}</p> 
                                            <p><b>Regimen:</b> {matrimonio.REGIMEN}</p>
                                            <p><b>Libro:</b> {matrimonio.LIBRO}</p>
                                            <p><b>Tomo:</b> {matrimonio.TOMO}</p>
                                            <p><b>Foja:</b> {matrimonio.FOJA}</p>
                                            <p><b>Mun Ofi:</b> {matrimonio.MUN_OFI}</p>
                                            <p><b>Acta Comp:</b> {matrimonio.ACTA_COMP}</p>
                                            <p><b>Número Oficial:</b> {matrimonio.NUM_OFI_COMP}</p>
                                            <p><b>Oficialía:</b> {matrimonio.OFICIALIA}</p>
                                            <p><b>Estado de la Oficialía:</b> {matrimonio.ESTADO_OFI}</p>

                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}
                    {divorcio && divorcio.length > 0 && (
                        <div className='mat'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Actas de Divorcio</h2>

                            {divorcio.map((divorcio, index) => (
                                <div key={index}>
                                    <div className='hermano'>


                                        <div className='columna'>
                                            <h2>Datos De El Divorciado</h2>
                                            <p><b>El Contrayente:</b> {replaceSpecialCharacter(divorcio.NOMBRE_DIVORCIADO)}</p>
                                            <p><b>Edad:</b> {divorcio.EDAD1}</p>
                                            <p><b>Localidad:</b> {divorcio.NACIONALIDAD1}</p>
                                            <p><b>Registrado:</b> {divorcio.LOCALIDAD1}</p>
                                            <p><b>Municipio:</b> {divorcio.MUNICIPIO1}</p>
                                            <p><b>Estado:</b> {divorcio.ESTADO1}{"\n"}</p>
                                            <br />
                                            <br />
                                            <br />
                                            {/* <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <p className='resolucion'> <b>RESOLUCION:</b> {divorcio.RESOLUCION}</p> */}

                                        </div>
                                        <div className='columna'>
                                            <h2>Datos De El Divorciada</h2>
                                            <p><b>El Contrayente:</b> {replaceSpecialCharacter(divorcio.NOMBRE_DIVORCIADA)}</p>
                                            <p><b>Edad:</b> {divorcio.EDAD2}</p>
                                            <p><b>Localidad:</b> {divorcio.NACIONALIDAD2}</p>
                                            <p><b>Registrado:</b> {divorcio.LOCALIDAD2}</p>
                                            <p><b>Municipio:</b> {divorcio.MUNICIPIO2}</p>
                                            <p><b>Estado:</b> {divorcio.ESTADO2}</p>
                                            <br />
                                            <br />

                                        </div>
                                        <div className='columna'>
                                            <h2>Datos Acta</h2>
                                            <p><b>Fecha Reg:</b> {divorcio.FECHA_REG}</p>
                                            <p><b>Libro:</b> {divorcio.LIBRO}</p>
                                            <p><b>Tomo:</b> {divorcio.TOMO}</p>
                                            <p><b>Foja:</b> {divorcio.FOJA}</p>
                                            <p><b>Mun Ofi:</b> {divorcio.NUM_OFI}</p>
                                            <p><b>Acta Comp:</b> {divorcio.ACTA_COMP}</p>
                                            <p><b>Número Oficial:</b> {divorcio.NUM_OFI_COMP}</p>
                                            <p><b>Oficialía:</b> {divorcio.OFICIALIA}</p>
                                            <p><b>Estado de la Oficialía:</b> {divorcio.ESTADO_OFI}</p>

                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}

                    {conyugue && conyugue.length > 0 && (
                        <div className='mat'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Acta de Conyuge</h2>

                            {conyugue.map((conyugue, index) => (
                                <div key={index}>
                                    <div className='hermano'>


                                        <div className='columna'>
                                            <h2>Datos del Registrado</h2>
                                            <p><b>Nombre:</b> {replaceSpecialCharacter(conyugue.NOMBRE_REGISTRADO)}</p>
                                            <p><b>Fecha de Nacimiento:</b> {conyugue.FECHA_NAC}</p>
                                            <p><b>Fecha de Registro:</b> {conyugue.FECHA_REG}</p>
                                            <p><b>Sexo:</b> {conyugue.SEXO_COMPLETO}</p>
                                            <p><b>Registrado:</b> {conyugue.REGISTRADO}</p>
                                            <p><b>Localidad:</b> {conyugue.ESTADO}</p>
                                            <p><b>Municipio:</b> {conyugue.MUNICIPIO}</p>
                                            <p><b>Estado:</b> {conyugue.ESTADO}</p>
                                            <p><b>País:</b> {conyugue.PAIS}</p>
                                            <p><b>CRIP:</b> {conyugue.CRIP}</p>
                                        </div>
                                        <div className='columna'>
                                            <h2>Padres</h2>
                                            <p><b>Padre:</b> {replaceSpecialCharacter(conyugue.PADRE)}</p>
                                            <p><b>Edad:</b> {conyugue.EDAD_PADRE}</p>
                                            <p><b>País:</b> {conyugue.PAIS_PADRE}</p>
                                            <p><b>Fecha de Nacimiento del Padre:</b> {conyugue.FECHA_NAC_PADRE}</p>
                                            <br />
                                            <br />
                                            <p><b>Madre:</b> {replaceSpecialCharacter(conyugue.MADRE)}</p>
                                            <p><b>Edad Madre:</b> {conyugue.EDAD_MADRE}</p>
                                            <p><b>País Madre:</b> {conyugue.PAIS_MADRE}</p>
                                            <p><b>Fecha de Nacimiento de la Madre:</b> {conyugue.FECHA_NAC_MADRE}</p>

                                        </div>
                                        <div className='columna'>
                                            <h2>Datos Acta</h2>
                                            <p><b>Libro:</b> {conyugue.LIBRO}</p>
                                            <p><b>Tomo:</b> {conyugue.TOMO}</p>
                                            <p><b>Foja:</b> {conyugue.FOJA}</p>
                                            <p><b>Mun. Oficialia:</b> {conyugue.MUN_OFI}</p>
                                            <p><b>Acta:</b> {conyugue.ACTA}</p>
                                            <p><b>Número Oficial:</b> {conyugue.NUM_OFI}</p>
                                            <p><b>Oficialía:</b> {conyugue.OFICIALIA}</p>
                                            <p><b>Estado de la Oficialía:</b> {conyugue.ESTADO_OFI}</p>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}
                    {hijos && hijos.length > 0 && (
                        <div className='mat'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Acta de Hijos</h2>

                            {hijos.map((hijos, index) => (
                                <div key={index}>
                                    <div className='hermano'>


                                        <div className='columna'>
                                            <h2>Datos del Registrado</h2>
                                            <p><b>Nombre:</b> {replaceSpecialCharacter(hijos.NOMBRE_REGISTRADO)}</p>
                                            <p><b>Fecha de Nacimiento:</b> {hijos.FECHA_NAC}</p>
                                            <p><b>Fecha de Registro:</b> {hijos.FECHA_REG}</p>
                                            <p><b>Sexo:</b> {hijos.SEXO_COMPLETO}</p>
                                            <p><b>Registrado:</b> {hijos.REGISTRADO}</p>
                                            <p><b>Localidad:</b> {hijos.ESTADO}</p>
                                            <p><b>Municipio:</b> {hijos.MUNICIPIO}</p>
                                            <p><b>Estado:</b> {hijos.ESTADO}</p>
                                            <p><b>País:</b> {hijos.PAIS}</p>
                                            <p><b>CRIP:</b> {hijos.CRIP}</p>

                                        </div>
                                        <div className='columna'>
                                            <h2>Padres</h2>
                                            <p><b>Padre:</b> {replaceSpecialCharacter(hijos.PADRE)}</p>
                                            <p><b>Edad:</b> {hijos.EDAD_PADRE}</p>
                                            <p><b>País:</b> {hijos.PAIS_PADRE}</p>
                                            <p><b>Fecha de Nacimiento del Padre:</b> {hijos.FECHA_NAC_PADRE}</p>
                                            <br />
                                            <br />
                                            <p><b>Madre:</b> {replaceSpecialCharacter(hijos.MADRE)}</p>
                                            <p><b>Edad Madre:</b> {hijos.EDAD_MADRE}</p>
                                            <p><b>País Madre:</b> {hijos.PAIS_MADRE}</p>
                                            <p><b>Fecha de Nacimiento de la Madre:</b> {hijos.FECHA_NAC_MADRE}</p>

                                        </div>
                                        <div className='columna'>
                                            <h2>Datos Acta</h2>
                                            <p><b>Libro:</b> {hijos.LIBRO}</p>
                                            <p><b>Tomo:</b> {hijos.TOMO}</p>
                                            <p><b>Foja:</b> {hijos.FOJA}</p>
                                            <p><b>Mun. Oficialia:</b> {hijos.Mun_Ofi}</p>
                                            <p><b>Acta:</b> {hijos.Acta}</p>
                                            <p><b>Número Oficial:</b> {hijos.NUM_OFI}</p>
                                            <p><b>Oficialía:</b> {hijos.OFICIALIA}</p>
                                            <p><b>Estado de la Oficialía:</b> {hijos.ESTADO_OFI}</p>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}

                    {hermanos && hermanos.length > 0 && (
                        <div className='mat'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Acta de Hermanos</h2>

                            {hermanos.map((hermano, index) => (
                                <div key={index}>
                                    <div className='hermano'>


                                        <div className='columna'>
                                            <h2>Datos del Registrado</h2>
                                            <p><b>Nombre:</b>{replaceSpecialCharacter(hermano.NOMBRE_REGISTRADO)}</p>
                                            <p><b>Fecha de Nacimiento:</b> {hermano.FECHA_NAC}</p>
                                            <p><b>Fecha de Registro:</b> {hermano.FECHA_REG}</p>
                                            <p><b>Sexo:</b> {hermano.SEXO_COMPLETO}</p>
                                            <p><b>Registrado:</b> {hermano.REGISTRADO}</p>
                                            <p><b>Localidad:</b> {hermano.ESTADO}</p>
                                            <p><b>Municipio:</b> {hermano.MUNICIPIO}</p>
                                            <p><b>Estado:</b> {hermano.ESTADO}</p>
                                            <p><b>País:</b> {hermano.PAIS}</p>
                                            <p><b>CRIP:</b> {hermano.CRIP}</p>
                                        </div>
                                        <div className='columna'>
                                            <h2>Padres</h2>
                                            <p><b>Padre:</b> {replaceSpecialCharacter(hermano.PADRE)}</p>
                                            <p><b>Edad:</b> {hermano.EDAD_PADRE}</p>
                                            <p><b>País:</b> {hermano.PAIS_PADRE}</p>
                                            <p><b>Fecha de Nacimiento del Padre:</b> {hermano.FECHA_NAC_PADRE}</p>
                                            <br />
                                            <br />
                                            <p><b>Madre:</b> {replaceSpecialCharacter(hermano.MADRE)}</p>
                                            <p><b>Edad Madre:</b> {hermano.EDAD_MADRE}</p>
                                            <p><b>País Madre:</b> {hermano.PAIS_MADRE}</p>
                                            <p><b>Fecha de Nacimiento de la Madre:</b> {hermano.FECHA_NAC_MADRE}</p>

                                        </div>
                                        <div className='columna'>
                                            <h2>Datos Acta</h2>
                                            <p><b>Libro:</b> {hermano.LIBRO}</p>
                                            <p><b>Tomo:</b> {hermano.TOMO}</p>
                                            <p><b>Foja:</b> {hermano.FOJA}</p>
                                            <p><b>Mun. Oficialia:</b> {hermano.MUN_OFI}</p>
                                            <p><b>Acta:</b> {hermano.ACTA}</p>
                                            <p><b>Número Oficial:</b> {hermano.NUM_OFI}</p>
                                            <p><b>Oficialía:</b> {hermano.OFICIALIA}</p>
                                            <p><b>Estado de la Oficialía:</b> {hermano.ESTADO_OFI}</p>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}


                    {padres && padres.length > 0 && (
                        <div className='pad'>
                            <h2 className='titulo-acta' style={{ float: 'left' }}>Acta de Padres</h2>

                            {padres.map((padre, index) => (
                                <div key={index}>
                                    <div className='padre'>

                                        <div className='columna'>
                                            <h2>Datos del Registrado</h2>
                                            <p><b>Nombre:</b> {replaceSpecialCharacter(padre.NOMBRE_REGISTRADO)}</p>
                                            <p><b>Fecha de Nacimiento:</b> {padre.FECHA_NAC}</p>
                                            <p><b>Fecha de Registro:</b> {padre.FECHA_REG}</p>
                                            <p><b>Sexo:</b> {padre.SEXO_COMPLETO}</p>
                                            <p><b>Registrado:</b> {padre.REGISTRADO}</p>
                                            <p><b>Localidad:</b> {padre.ESTADO}</p>
                                            <p><b>Municipio:</b> {padre.MUNICIPIO}</p>
                                            <p><b>Estado:</b> {padre.ESTADO}</p>
                                            <p><b>País:</b> {padre.PAIS}</p>
                                            <p><b>CRIP:</b> {padre.CRIP}</p>
                                        </div>
                                        <div className='columna'>
                                            <h2>Padres</h2>
                                            <p><b>Padre:</b> {replaceSpecialCharacter(padre.PADRE)}</p>
                                            <p><b>Edad:</b> {padre.EDAD_PADRE}</p>
                                            <p><b>País:</b> {padre.PAIS_PADRE}</p>
                                            <p><b>Fecha de Nacimiento del Padre:</b> {padre.FECHA_NAC_PADRE}</p>
                                            <br />
                                            <br />
                                            <p><b>Madre:</b> {replaceSpecialCharacter(padre.MADRE)}</p>
                                            <p><b>Edad Madre:</b> {padre.EDAD_MADRE}</p>
                                            <p><b>País Madre:</b> {padre.PAIS_MADRE}</p>
                                            <p><b>Fecha de Nacimiento de la Madre:</b> {padre.FECHA_NAC_MADRE}</p>

                                        </div>
                                        <div className='columna'>
                                            <h2>Datos Acta</h2>
                                            <p><b>Libro:</b> {padre.LIBRO}</p>
                                            <p><b>Tomo:</b> {padre.TOMO}</p>
                                            <p><b>Foja:</b> {padre.FOJA}</p>
                                            <p><b>Mun. Oficialia:</b> {padre.MUN_OFI}</p>
                                            <p><b>Acta:</b> {padre.ACTA}</p>
                                            <p><b>Número Oficial:</b> {padre.NUM_OFI}</p>
                                            <p><b>Oficialía:</b> {padre.OFICIALIA}</p>
                                            <p><b>Estado de la Oficialía:</b> {padre.ESTADO_OFI}</p>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}






export default withRouter(BusquedaCivilDetalles);
